import React, { useContext, useState } from 'react'
import { useUtmQuery } from '../hooks'
import { useNavigate } from 'react-router'
import actions from '../actions'
import { AppContext } from '../appContext'
import { AuthError, LoginButton, Section } from '../components'
import { Navigate, useLocation } from 'react-router-dom'
import { errorToString } from '@oneethos/shared'

export const LoginPage = () => {
  const { route, code, msg } = useUtmQuery()
  const [email, setEmail] = useState('')
  const [installerID, setInstallerId] = useState('')
  const [success, setSuccess] = useState('')
  const [info, setInfo] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [requireInstallerID, setRequireInstallerID] = useState(false)
  const { dispatch, state: { registration: { installer, authError } } } = useContext(AppContext)

  const location = useLocation()
  const navigate = useNavigate()
  const search = useUtmQuery()

  if (installer) {
    // TODO: needs revisited, uncommenting leads to redirect loop if logged in and 
    // can't access apply page
    // const route = location.state?.route || search.route
    // if (route) {
    //   return <Navigate to={route} />
    // }

    // redirect if they're already logged in
    return <Navigate to="/projects" />
  }

  return <div className="login-page">
    {code ? <AuthError authError={code} /> : null}
    <Section>
      <p>
        If you have registered previously, you can request a new
        login link be sent to your email.
      </p>
      <div className="form-group">
        <label>Email</label>
        <input
          type="email"
          className="form-control"
          value={email}
          disabled={submitting}
          onChange={ev => setEmail(ev.target.value)}
        />
      </div>
      {requireInstallerID ? <div className="form-group">
        <label>Installer ID</label>
        <input
          type="text"
          className="form-control"
          value={installerID}
          disabled={submitting}
          onChange={ev => setInstallerId(ev.target.value)}
        />
      </div> : null}
      {info ? <div className="alert alert-info">{info}</div> : null}
      <div className="buttons" style={{ marginBottom: '1em' }}>
        <LoginButton
          email={email}
          submitting={submitting}
          setSubmitting={tf => {
            setSubmitting(tf)
            if (tf) {
              dispatch(actions.setAuthError(''))
            }
          }}
          onSuccess={msg => {
            // toast.success(msg)
            navigate('/verify-email', { state: { code: msg , route: route}})
          }}
          installerID={installerID}
          route={route}
          onError={ex => {
            if (ex.code === 'INSTALLER_ID_REQUIRED') {
              setRequireInstallerID(true)
              setInfo('Installer ID Required')
            } else {
              dispatch(actions.setAuthError(errorToString(ex)))
            }
          }}
        />
      </div>
      {success ? <div className="alert alert-success">{success}</div> : null}
    </Section>
    <Section>
      <p>If you have not registered, please complete your registration</p>
      <button type="button"
        className="btn btn-success"
        onClick={() => navigate(`/profile`)}
      >Register Now</button>
    </Section>
  </div>
}

export default LoginPage
